export const normalizePhoneNumber = (value: string) => value.replace(/[\s()-]/g, '').replace(/^00/, '+')

export const isPhoneNumber = (value: string) => /^\+?[0-9]{8,15}$/.test(normalizePhoneNumber(value))
